<template>
	<transition name="vue-backdrop" appear>
		<div
			@click="$emit('close')"
			v-show="isShowModal"
			class="vue-backdrop"
			role="dialog"
			:class="isChildModal ? 'child-backdrop' : ''"
		>
			<template v-if="isLoading">
				<img
					class="loader"
					src="/safejournal/app-assets/images/common/loader.gif"
				/>
			</template>
		</div>
	</transition>
	<transition name="vue-modal" appear v-if="!isLoading">
		<div
			v-show="isShowModal"
			@click.stop
			class="vue-modal"
			role="document"
			:class="isChildModal ? 'child-modal' : ''"
			ref="modal"
		>
			<div class="modal-dialog modal-lg" :style="style">
				<div class="modal-content">
					<div class="modal-header">
						<h4 class="modal-title" id="myModalLabel1">
							<slot name="header" />
						</h4>
						<div class="d-flex align-items-center">
							<slot name="minimize"></slot>
							<button
								@click="$emit('close')"
								type="button"
								class="close"
								data-dismiss="modal"
								aria-label="Close"
							>
								<span aria-hidden="true">×</span>
							</button>
						</div>
					</div>
					<div class="modal-body">
						<slot name="body"></slot>
					</div>
				</div>
			</div>
		</div>
	</transition>
</template>
<script setup>
import { onMounted, onUnmounted, ref, watch } from "vue";
const props = defineProps({
	isShowModal: Boolean,
	isChildModal: Boolean,
	style: String,
	isLoading: Boolean,
	isSaving: Boolean,
	submitState: Object,
});
const body = document.querySelector("body");
onMounted(() => {
	body.classList.toggle("modal-open");
});
onUnmounted(() => {
	body.classList.toggle("modal-open");
});
defineEmits(["close"]);

const modal = ref(null);
watch(props.submitState, () => {
	modal.value.scrollTo(0, 0);
});
</script>
